var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { useBEM } from '../../utils';
import { Divider } from '../Divider';
import { Scroller } from './Scroller';
import "./styles.css";
var _a = useBEM('lk-ui__tabs'), tabClassName = _a[0], _ = _a[1], tabElement = _a[2];
var _b = tabElement('content'), contentClassName = _b[0], contentModifier = _b[1];
export var Tabs = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.align, align = _c === void 0 ? 'left' : _c, _d = _a.divider, divider = _d === void 0 ? true : _d, props = __rest(_a, ["className", "children", "align", "divider"]);
    var combinedClassName = cn(contentClassName, (_b = {},
        _b[contentModifier('align-left')] = align === 'left',
        _b[contentModifier('align-center')] = align === 'center',
        _b[contentModifier('align-right')] = align === 'right',
        _b));
    return (React.createElement("div", __assign({ className: cn(tabClassName, className), ref: ref }, props),
        React.createElement(Scroller, { className: combinedClassName }, children),
        divider && React.createElement(Divider, { className: 'lk-ui__tabs-divider' })));
});
